import React, { useState } from "react";
import styled from "styled-components";

const FlagIcon = styled.div`
  margin-right: 1rem;

  svg {
    display: block;
  }
`;

const Styled = styled.div<Props>`
  padding: 1rem;
  cursor: pointer;
  background-color: ${(props) => (props.active ? "#f0f0f0" : "#fff")};
  display: flex;
  align-items: center;
  transition:
    background-color 0.2s,
    color 0.2s;
  color: #333;

  ${(props) => {
    if (props.active) {
      return `
      border-left: solid 3px #006699;
      color: #000;
      `;
    }
  }}

  &:hover {
    background-color: #f7f7f7;
  }
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  flagged?: boolean;
}

const NavigationItem: React.FC<Props> = (props) => {
  return (
    <Styled {...props}>
      {props.flagged && (
        <FlagIcon>
          <svg viewBox="0 0 512 512" width="12" fill="#d72020">
            <g>
              <rect height="490" rx="21.56" width="43.12" x="52.54" y="11" />
              <path d="m442.19 184.79-346.53-136.46v323.67l346.53-136.48c23.03-9.07 23.03-41.66 0-50.73z" />
            </g>
          </svg>
        </FlagIcon>
      )}
      {props.children}
    </Styled>
  );
};

export default NavigationItem;
